import React from 'react'
import Headerteam from '../componenst/Teamrankteam/Headerteam'
import Navbar from '../componenst/Navbar'
import Cardheader from '../componenst/Teamrankteam/Cardheader'
import Modalpemain from '../componenst/Teamrankteam/Modalpemain';
import { Container, Form } from "react-bootstrap";
import { useState } from 'react';
import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import imageCompression from "browser-image-compression";
import { ToastContainer, toast } from "react-toastify";
import { Link } from 'react-router-dom';
import { LazyLoadComponent, LazyLoadImage } from 'react-lazy-load-image-component';

export default function Teamrankteam() {
    const [team, setTeam] = useState([]);
    const [logo, setLogo] = useState('');
    const [namateam, setNamateam] = useState('')
    const [modalShow, setModalShow] = React.useState(false);
    const [modalShow1, setModalShow1] = React.useState(false);
    const [modaledit, setModalEdit] = React.useState(false);
    const [alertnamateam, setAlertnamateam] = useState(false);
    const [nameImg, setNameImg] = useState("");
    const [valueimg, setvalueimg] = useState("");
    const [img, setImg] = useState("");
    const [image, setImage] = useState(null);
    const [loadingUpload, setLoadingUpload] = useState('');
    const [loading, setLoading] = useState(false);
    const [inputteam, setInputteam] = useState(false);
    const [pemain, setPemain] = useState([]);

    const upload_preset = process.env.REACT_APP_UPLOAD_PRESET_RANKTEAM;
    const cloud_name = process.env.REACT_APP_CLOUD_NAME_RANKTEAM;
    const urlapi = process.env.REACT_APP_BASE_URL;

    const [nama, setNama] = useState('')
    const [posisi, setPosisi] = useState('');
    const [nik, setNik] = useState('');
    const [alertnama, setAlertnama] = useState(false);
    const [alertposisi, setAlertposisi] = useState(false);
    const [alertnik, setAlertnik] = useState(false);
    const [jmlpemain, setJmlpemain] = useState(0)
    const [kuota, setKuota] = useState(0);
    const [panjangnik, setPanjangnik] = useState('')
    const [notifnik, setNotifnik] = useState('')
    const [usernik, setUserNik] = useState('');

    const [editid, setEditId] = useState('');
    const [editnama, setEditNama] = useState('');
    const [editposisi, setEditPosisi] = useState('');
    const [editnik, setEditNik] = useState('');
    const [statusteam, setStatusteam] = useState('');
    const [statusaddpemainbaru, setStatusaddpemainbaru] = useState('');
    const [showfoto, setShowfoto] = useState('');



    const getTeam = async () => {
        try {
            const response = await axios.get(urlapi + "Datateam?id_user=" + localStorage.getItem("id"));
            setTeam(response.data);
        } catch (error) {

        }
    }

    const handleChangeImg = async (e) => {
        setLoadingUpload('load')
        const file = e.target.files[0];
        setImg(e.target.files[0]);
        // console.log(e);
        setvalueimg(e.target.value);
        setNameImg(e.target.files[0].name);
        const options = {
            maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
            maxWidthOrHeight: 800, // Dimensi maksimum
            useWebWorker: true,
        };

        try {
            const compressedFile = await imageCompression(file, options);
            // Pratinjau gambar
            // setPreview(URL.createObjectURL(compressedFile));
            setImage(compressedFile); // Simpan gambar yang sudah dikompres
            setLoadingUpload('berhasil')
            console.log(compressedFile);
        } catch (error) {
            console.error("Gagal mengompres gambar:", error);
        }

    };

    const handledaftarteam = async () => {
        if (namateam == '' || valueimg == '') {
            setAlertnamateam(true)
        } else {
            setAlertnamateam(false)
            setLoading(true);
            if (!image) return
            const data = new FormData();
            data.append('file', image);
            data.append('upload_preset', upload_preset);
            data.append('cloud_name', cloud_name);

            const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`, {
                method: "POST",
                body: data
            })
            const uploadedImageUrl = await res.json()
            addteam(uploadedImageUrl.url);
        }
    }


    const addteam = async (image) => {

        // console.log(image);

        await axios
            .post(urlapi + "Datateam", {
                id_user: localStorage.getItem("id"),
                namateam: namateam,
                logoteam: image,
            })

            .then((response) => {
                getTeam();
                console.log(response.data);
                setLoading(null);
                setInputteam(true);
                // notify();
                // navigate("/daftarteamrankteam/add");
            })
            .catch((error) => {
                console.log(error.message);
            });
    }

    const getPemain = async () => {
        try {
            const response = await axios.get(
                urlapi + "Pemainrankteam?id_user=" + localStorage.getItem("id")
            );
            // console.log(response.data);
            setPemain(response.data);
        } catch (error) { }
    };

    const handlenama = (e) => {
        setNama(e.target.value);
        if (e.target.value == '') {
            setAlertnama(true)
        } else {
            setAlertnama(false);
        }
    }

    const handlenik = (e) => {
        setNik(e.target.value);
        handlenik2(e.target.value)
        if (e.target.value == '') {
            setAlertnik(true)
        } else {
            setAlertnik(false);
        }
    }

    const handlepoisi = (e) => {

        if (e.target.value == '') {
            setAlertposisi(true)
        } else {
            setPosisi(e.target.value)
            setAlertposisi(false);
        }
    }



    const handlenamaedit = (e) => {
        setEditNama(e.target.value);
        if (e.target.value == '') {
            setAlertnama(true)
        } else {
            setAlertnama(false);
        }
    }

    const handlenikedit = (e) => {
        setEditNik(e.target.value);
        handlenik2(e.target.value)
        if (e.target.value == '') {
            setAlertnik(true)
        } else {
            setAlertnik(false);
        }
    }

    const handlepoisiedit = (e) => {
        setEditPosisi(e.target.value)
        if (e.target.value == '') {
            setAlertposisi(true)
        } else {
            setPosisi(e.target.value)
            setAlertposisi(false);
        }
    }


    const handlepemain = () => {

        if (nama == '') {
            setAlertnama(true);
        } else if (nik == '') {
            setAlertnik(true)
        } else if (posisi == '') {
            setAlertposisi(true);
        } else {
            setAlertnama(false);
            setAlertnik(false);
            setAlertposisi(false);
            setPanjangnik('');

            if (statusaddpemainbaru == '1') {
                addPemainbaru();
            } else {
                addPemain();
            }

        }

    }

    const notify = () =>
        toast.success("Pemain berhasil ditambah", {
            position: toast.POSITION.TOP_CENTER,
        });

    const notifyfull = () =>
        toast.error("Opps Pemain sudah memenuhi kuoata", {
            position: toast.POSITION.BOTTOM_CENTER,
        });

    const notifhapus = () =>
        toast.success("Pemain berhasil dihapus", {
            position: toast.POSITION.TOP_CENTER,
        });

    const addPemain = async () => {
        await axios
            .post(urlapi + "Pemainrankteam", {
                rowid: '',
                id_user: localStorage.getItem("id"),
                nama_pemain: nama,
                posisi: posisi,
                no_punggung: '',
                nik: nik,
                nickname: '',
            })
            .then((response) => {
                console.log(response.data);
                setModalShow1(false)
                setNama('')
                setNik('')
                setPosisi('');
                getPemain()
                cekJmlpemain();
                if (response.data.kuota == 'full') {
                    notifyfull();
                } else {
                    notify();
                }
            })
            .catch((error) => {
                console.log(error.message);
            });
    }


    const addPemainbaru = async () => {
        await axios
            .post(urlapi + "Pemainrankteambaru", {
                rowid: '',
                id_user: localStorage.getItem("id"),
                nama_pemain: nama,
                posisi: posisi,
                no_punggung: '',
                nik: nik,
                nickname: '',
            })
            .then((response) => {
                console.log(response.data);
                setModalShow1(false)
                setNama('')
                setNik('')
                setPosisi('');
                getPemain()
                cekJmlpemain();

                if (response.data.kuota == 'full') {
                    notifyfull();
                } else {
                    notify();
                }


            })
            .catch((error) => {
                console.log(error.message);
            });
    }

    const kuotapemain = async () => {
        try {
            const response = await axios.get(urlapi + "Kuotapemain");
            setKuota(response.data.jml);
        } catch (error) {

        }
    }

    const cekJmlpemain = async () => {
        try {
            const response = await axios.get(
                urlapi +
                "Pemainrankteam2?jmlpemain=true" +
                "&&id_user=" +
                localStorage.getItem("id")
            );

            // console.log(response.data.jml);
            setJmlpemain(response.data.jml)
        } catch (error) { }
    };

    const handlenik2 = (e) => {
        // setNik(e);
        ceknik(e);
        if (e.length == 16) {
            setPanjangnik("true");
        } else if (e.length > 16) {
            setPanjangnik("false1");
        } else if (e.length < 16) {
            setPanjangnik("false2");
        }
    };

    const ceknik = async (nik) => {
        try {
            const response = await axios.get(urlapi + "Ceknik?nik=" + nik);
            // console.log(response.data);
            if (response.data == "") {
                setNotifnik(false);
            } else {
                setNotifnik(true);

            }
        } catch (error) {
            setNotifnik(false);
        }
    };


    const hapuspemain = async (id) => {
        try {
            const response = await axios.get(urlapi + "Hapuspemain?id=" + id);
            console.log(response.data);
            notifhapus();
            getPemain();
            // jmlPememainrankteam();
            cekJmlpemain();
        } catch (error) { }
    };

    const handleeditpemain = (id, nama, posisi, nik) => {
        setAlertposisi('');
        setAlertnama('');
        setAlertnik('');
        setNotifnik('')
        setPanjangnik('')
        setEditId(id);
        setEditNama(nama);
        setEditPosisi(posisi);
        setEditNik(nik);
        setModalEdit(true);


    }

    const editPemain = async () => {
        await axios.post(urlapi + "Ubahpemainrankteam", {
            id: editid,
            posisi: editposisi,
            nama: editnama,
            no_punggung: '',
            nickname: '',
            nik: editnik
        })
            .then((response) => {
                console.log(response.data);
                setEditId('');
                setEditNama('');
                setEditNik('');
                setEditPosisi('');
                setModalEdit(false);
                getPemain();
                notifyEdit()
            })
            .catch((error) => {
                console.log(error.message);

            })
    }

    const notifyEdit = () =>
        toast.success("Pemain berhasil diedit", {
            position: toast.POSITION.TOP_CENTER,
        });

    const cekstatusteam = async () => {
        try {
            const response = await axios.get(
                urlapi + "Cekstatusteam?id=" + localStorage.getItem("id")
            );
            // console.log(response.data);
            setStatusteam(response.data.status);
            setStatusaddpemainbaru(response.data.tambah_pemain)
        } catch (error) { }
    };

    const getShowfoto = async () => {
        try {
            const response = await axios.get(urlapi + "Showfotopemain");
            setShowfoto(response.data.status);


        } catch (error) {
            console.log(error);

        }
    }


    useEffect(() => {
        getTeam();
        getPemain();
        cekJmlpemain();
        kuotapemain();
        cekstatusteam()
        getShowfoto();
    }, [])

    const empty = [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
    ];
    return (
        <div className="trt-page">
            <Navbar judul="Team rank team" aicon='true' />
            <Headerteam />
            <Cardheader />

            {statusteam == 1 ?
                <div className="container">
                    <div className="trt-status-banner active">
                        <div className="trt-status-banner-icon"><i className="fas fa-circle-check"></i></div>
                        <div className="trt-status-banner-content">
                            <b>Halo, {localStorage.getItem('nama')}!</b>
                            Team anda sudah aktif, silahkan bermain rank team sekarang juga
                        </div>
                    </div>
                </div>
                :
                <div className="container">
                    <div className="trt-status-banner info">
                        <div className="trt-status-banner-icon"><i className="fas fa-circle-info"></i></div>
                        <div className="trt-status-banner-content">
                            <b>Halo, {localStorage.getItem('nama')}!</b>
                            {team == '' ? 'Team anda belum terdaftar, silahkan masukan logo dan nama team anda' : 'Input data pemain team anda untuk dapat bermain rank team'}
                        </div>
                    </div>
                </div>
            }

            <div className="container">
                <div className={team == '' || statusaddpemainbaru == '1' ? 'd-none' : 'trt-status-banner info'}>
                    <div className="trt-status-banner-icon"><i className="fas fa-users"></i></div>
                    <div className="trt-status-banner-content">
                        Jumlah maksimal kuota pemain untuk bermain rank team sebanyak <b>{kuota} pemain</b>
                    </div>
                </div>

                <div className={statusaddpemainbaru == '1' ? 'trt-status-banner info' : 'd-none'}>
                    <div className="trt-status-banner-icon"><i className="fas fa-user-plus"></i></div>
                    <div className="trt-status-banner-content">
                        <b>Halo, {localStorage.getItem('nama')}</b>
                        Anda dapat menambahkan kuota pemain baru untuk bermain rank team
                    </div>
                </div>
            </div>

            <div className={team == '' ? 'd-none' : ''}>
                <div className="trt-section-title">
                    <i className="fas fa-users"></i> Pemain Anda
                </div>
                <div className="container">
                    <div className="trt-note-card">
                        <i className="fas fa-triangle-exclamation"></i>
                        Jika Foto/KTP pemain masih kosong, edit data pemain untuk mengupload foto KTP dan foto pemain
                    </div>
                </div>
                <div className="trt-player-list">
                    <div className="row g-3">
                        {pemain.map((data, index) => {
                            return (
                                <div key={index} className="col-md-4 col-6">
                                    <div className="trt-player-card">
                                        <div className={`trt-player-tag ${data.baru == 1 ? 'new' : 'regular'}`}>
                                            <i className={data.baru == 1 ? 'fas fa-star' : 'fas fa-futbol'}></i>{" "}
                                            {data.baru == 1 ? 'New player' : 'Player rank team'}
                                        </div>
                                        <div className="trt-player-body">
                                            {showfoto == 1 ?
                                                <LazyLoadImage
                                                    alt={data.nama}
                                                    effect="blur"
                                                    src={data.foto || "/img/pm.png"}
                                                    className="trt-player-avatar"
                                                />
                                                :
                                                <LazyLoadImage
                                                    alt={data.nama}
                                                    effect="blur"
                                                    src="/img/pm.png"
                                                    className="trt-player-avatar"
                                                />
                                            }
                                            <div className="trt-player-name">{data.nama}</div>
                                            <div className="trt-player-pos">{data.posisi}</div>
                                            <div className="trt-player-nik">{data.nik}</div>
                                            <div className={statusteam == 1 ? 'd-none' : 'trt-player-actions'}>
                                                <Link to={"/editpemain/" + data.id} className="trt-btn trt-btn-edit">
                                                    <i className="fas fa-edit"></i> Edit
                                                </Link>
                                                <button className="trt-btn trt-btn-del" onClick={() => hapuspemain(data.id)}>
                                                    <i className="fas fa-trash"></i> Hapus
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

                <div className='mt-4'>
                    <div className={team != '' ? 'd-none' : 'trt-empty-center'}>
                        <img src="/img/mmm.png" className="img-fluid" alt="team" />
                        <div className="trt-empty-text">
                            Upload logo team anda dan nama team anda. Pastikan logo team anda berformat gambar seperti jpeg, jpg dan png
                        </div>
                        {modalShow == false ?
                            <button className='trt-btn trt-btn-solid rounded-pill' onClick={() => setModalShow(true)}>
                                <i className="fas fa-shield-halved"></i> Daftarkan team anda sekarang
                            </button> : ''
                        }
                    </div>


                    {pemain == '' && team != '' ?
                        <div className='trt-empty-center'>
                            <img src="img/addpemainbaru.png" alt="" className='img-fluid' />
                            <div className="trt-empty-text">
                                Tambah pemain team anda dengan benar sesuai jumlah kuota yang telah ditentukan
                            </div>
                        </div> : ''}

                    {team != '' ? <div className=''>
                        {/* {statusteam == 0 ? <Link to='/tambahpemain' className='btn w-100 rounded-pill' id='btnmmsc' onClick={() => setModalShow1(true)} style={{ cursor: 'pointer' }}><i className='fas fa-user-plus'></i> Tambah pemain team anda</Link> : ''} */}

                    </div> : ''}

                    {/* {statusaddpemainbaru == '1' ?
                        <>
                            <button className='btn w-100 rounded-pill' id='btnmmsc' onClick={() => setModalShow1(true)} style={{ cursor: 'pointer' }}><i className='fas fa-user-plus'></i> Tambah pemain baru team anda</button>
                        </>
                        : <></>
                    } */}

                    {/* Modal Upload logo team */}
                    <Modal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >

                        <Modal.Body>

                            <div className={loading == true ? 'text-center mt-5' : 'text-center mt-5 d-none'}>
                                <div class="spinner-grow text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <div class="spinner-grow text-secondary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <div class="spinner-grow text-success" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <h5>Loading ....</h5>
                                <div className='text-secondary'>Mohon untuk menunggu proses <br />pendaftaran team anda</div>
                                <div className='text-primary mt-3'>Ulangi proses ini ?</div>
                            </div>

                            <div className={inputteam == true ? 'mt-5 mb-5' : 'd-none'}>
                                <center>
                                    <img src="/img/inputteamsukses.png" class="img-fluid" alt="..." style={{ height: '200px' }}></img>
                                    <h3 className='fw-bold' style={{ color: '#2b2e5a' }}><i className='fas fa-circle-check'></i> Selamat {localStorage.getItem('nama')}</h3>
                                    <div className='text-secondary'>Team anda berhasil dibuat, daftarkan pemain team anda sekarang untuk bermain rank team</div>
                                    <a href='' className='btn rounded-pill mt-1' id='btnmmsc'>Daftarkan pemain team anda</a>
                                </center>
                            </div>

                            <div className={loading == false ? '' : 'd-none'}>
                                <div className='form-group mt-4'>
                                    <div className="mb-3">
                                        <div class="form-floating mb-3">
                                            <input type="text" class={`form-control ${alertnamateam == false || namateam !== '' ? '' : 'is-invalid'}`} id="floatingInput" onChange={(e) => setNamateam(e.target.value)} />
                                            <label for="floatingInput">Nama Team</label>
                                            <small className={`text-danger ${alertnamateam == false || namateam != '' ? 'd-none' : ''}`}>Nama team tidak boleh kosong</small>
                                        </div>
                                    </div>
                                </div>

                                <Form.Group className="mb-3" controlId="formBasicupload">
                                    <label
                                        for="images"
                                        class={`drop-container ${valueimg == '' ? 'border-danger' : 'border-primary'}`}
                                        id="dropcontainer"
                                    >
                                        <span class="drop-title">
                                            {nameImg == "" ? (
                                                "Upload logo team"
                                            ) : loadingUpload == 'load' ? <> <div class="spinner-border" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div> Loading .....</> : loadingUpload == 'berhasil' ? <>
                                                <i class="fa-solid fa-circle-check text-success"></i>{" "}
                                                Upload sukses
                                            </>
                                                : <></>

                                            }
                                        </span>

                                        <input
                                            type="file"
                                            id="images"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={(e) => handleChangeImg(e)}
                                            required
                                        />
                                    </label>
                                    <div className='text-center mt-2 text-secondary' style={{ fontSize: '12px' }}>
                                        Logo team tidak boleh koosng, upload logo team anda dengan format Gambar (JPG, JPEG
                                        & PNG)
                                    </div>
                                    <center>
                                        <button className='btn mt-3 rounded-pill text-center' id='btnmmsc' onClick={() => handledaftarteam()}>Buat team anda</button>
                                    </center>
                                </Form.Group>
                            </div>
                        </Modal.Body>

                    </Modal>
                    {/* End */}

                    <ToastContainer />

                </div>

            {statusteam == 1 ? <>
                <div className="card fixed-bottom border-0" style={{ borderRadius: "0px" }}>
                    <div className="card-body">

                        {statusaddpemainbaru == '1' ?
                            <>
                                <div className='row'>
                                    <div className='col-sm-3'></div>
                                    <div className='col-sm-3 col-6'>
                                        <Link to='/tambahpemain' className='btn w-100 rounded-pill' id='btnmmsc' style={{ cursor: 'pointer', fontSize: '12px' }}><i className='fas fa-user-plus'></i> Tambah pemain</Link>
                                    </div>
                                    <div className='col-sm-3 col-6'>
                                        <Link to='/jadwalrankteam' className='btn w-100 rounded-pill' id='btnmmsc' style={{ fontSize: '11px' }}> <i className='fas fa-shield-halved'></i> Bermain rank team</Link>
                                    </div>

                                    <div className='col-sm-3'></div>
                                </div>
                            </>
                            :
                            <>
                                <div className='row'>
                                    <div className='col-sm-3'></div>
                                    {/* <div className='col-sm-3 col-6'>
                                        <Link to='/tambahpemain' className='btn w-100 rounded-pill' id='btnmmsc' style={{ cursor: 'pointer', fontSize: '12px' }}><i className='fas fa-user-plus'></i> Tambah pemain</Link>
                                    </div> */}
                                    <div className='col-sm-6 col-12'>
                                        <Link to='/jadwalrankteam' className='btn w-100 rounded-pill' id='btnmmsc' style={{ fontSize: '11px' }}> <i className='fas fa-shield-halved'></i> Bermain rank team</Link>
                                    </div>

                                    <div className='col-sm-3'></div>
                                </div>
                            </>
                        }




                    </div>
                </div></> :
                <>
                    {team != '' ? <><div className="card fixed-bottom border-0" style={{ borderRadius: "0px" }}>
                        <div className="card-body">

                            <div className='row'>
                                <div className='col-sm-3'></div>
                                <div className='col-sm-6'>
                                    <Link to='/tambahpemain' className='btn w-100 rounded-pill' id='btnmmsc' onClick={() => setModalShow1(true)} style={{ cursor: 'pointer' }}><i className='fas fa-user-plus'></i> Tambah pemain team anda</Link>
                                </div>
                                <div className='col-sm-3'></div>
                            </div>


                        </div>
                    </div></> : <> </>}


                </>
            }

        </div >
    )
}
